import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  private appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: false,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableExceptionTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
        correlationHeaderExcludedDomains: [
          'cdn.designsystem.volvogroup.com',
          '*.designsystem.volvogroup.com',
          'fonts.googleapis.com',
          '*.googleapis.com'
        ]
      },
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string, customProperties?: Record<string, any>) {

    this.appInsights.trackPageView({
      name: name,
      uri: url,
      properties: customProperties || {}
    });
  }

  logEvent(eventName: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackEvent({ name: eventName }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }

  logDependency(id: string, method: string, absoluteUrl: string, pathName: string, totalTime: number, success: boolean, responseCode: number): void {
    this.appInsights.trackDependencyData({
      id: id,
      name: method,
      data: absoluteUrl,
      duration: totalTime,
      success: success,
      responseCode: responseCode
    });
  }

  logUserAction(action: string, properties?: Record<string, any>): void {
    this.logEvent('UserAction', {
      action,
      timestamp: new Date().toISOString(),
      ...properties
    });
  }

  setUser(userId: string): void {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  clearUser(): void {
    this.appInsights.clearAuthenticatedUserContext();
  }
}
